import { Field } from '@sitecore-jss/sitecore-jss-nextjs';

import { ContentDetailItem } from 'src/types/ContentDetailsItem';

import RcniLinkFields from 'src/components/contentOverview/RcniLinkFields';

type RcniFields = RcniLinkFields & {
	RCNiArticleUrl?: Field<string>;
};

export function getRcniResourceUrl(fields: RcniFields, contentDetailItem: ContentDetailItem | null) {
	if ((!contentDetailItem?.IsCpdArticle && !contentDetailItem?.IsLmsModule) || !fields.RCNiArticleUrl) {
		return;
	}

	const url = contentDetailItem.IsCpdArticle
		? `${fields.RCNiMPSSSOSpentityIdParameterName}=${fields.RCNiMPSSSOSpentityId}&${fields.RCNiMPSSSORelayStateParameterName}=${fields.RCNiArticleUrl.value}`
		: `${fields.RCNiImpelsysSSOSpentityIdParameterName}=${fields.RCNiImpelsysSSOSpentityId}&${fields.RCNiImpelsysSSORelayStateParameterName}=${fields.RCNiArticleUrl.value}`;

	return `${fields.RCNiSAMLIdPBaseUrl}?${url}`;
}
